import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import EMTLevel from "../../components/emtLevel";
import Caution from "../../components/caution";
import Note from "../../components/note";
import MyLink from "../../components/myLink";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <EMTLevel level="basic" mdxType="EMTLevel">
  <ul>
    <li>
      <MyLink to="/sections/1/1.0-routine-patient-care" mdxType="MyLink">
        1.0 Routine Patient Care
      </MyLink>
    </li>
    <li>
      If patient is unconscious or seizing, transport on left side (recovery position).
    </li>
    <li>
      Glucose or glucagon are indicated only for documented hypoglycemia. If
      authorized and trained to do so, obtain a blood sugar reading.
    </li>
    <ul>
      <li>
        If glucose is known to be <strong>less than 70 mg/dL</strong> and the patient is conscious and
        can speak and swallow, administer oral glucose or other sugar source as
        tolerated.
      </li>
      <li>
        <strong>Oral glucose.</strong> One dose is one tube.
        <ul>
          <li>Other sugar sources are acceptable</li>
        </ul>
      </li>
      <li>
        A second dose may be necessary after 10 minutes if patient remains
        symptomatic.
      </li>
    </ul>
  </ul>
  <strong>
    IF the Patient is unconscious or unable to safely swallow and IF approved
    under
  </strong>
  <MyLink to="@TODO" mdxType="MyLink">
    Protocol 6.10 Glucagon for Hypoglycemia by EMT Basic:
  </MyLink>
  <ul>
    <li>Glucagon 1mg IM</li>
    <ul>
      <li>
        Recheck glucose 15 minutes after administration of glucagon.
      </li>
      <li>
        May repeat glucagon 1mg IM if glucose level is &lt;70mg/dL with
        continued altered mental status.
      </li>
    </ul>
  </ul>
    </EMTLevel>
    <EMTLevel level="advanced" mdxType="EMTLevel">
  <ul>
   <li>
     For <strong>HYPO</strong>glycemic emergency:
   </li>
   <ul>
    <li>
      Dextrose 12.5 g IV/IO. Recheck glucose 5 minutes after administration of
      dextrose.
    </li>
    <li>
      May repeat dextrose up to 25 g IV/IO if glucose level is &lt;70mg/dL with
      continued altered mental status.
    </li>
    <li>
      Glucagon 1mg IV/IO/IM/IN if unable to establish IV access
    </li>
    <li>
      Recheck glucose 15 minutes after administration of glucagon.
    </li>
    <li>
      May repeat glucagon 1mg IV/IO/IM/IN if glucose level is &lt;70mg/dL
      with continued altered mental status.
    </li>
  </ul>
  <li>
    For <strong>HYPER</strong>glycemic emergency:
  </li>
    <ul>
      <li>
        Administer 500mL fluid bolus, then 250ml/hr.
      </li>
    </ul>
  </ul>
    </EMTLevel>
    <EMTLevel level="advanced" medControl={true} mdxType="EMTLevel">
  <ul>
    <li>Additional doses of above medication</li>
  </ul>
    </EMTLevel>
    <EMTLevel level="paramedic" mdxType="EMTLevel">
  <ul>
    <li>See Above protocols</li>
  </ul>
    </EMTLevel>
    <Caution id="caution-1" mdxType="Caution">
  If cerebrovascular accident is suspected, follow
  <MyLink to="@TODO" mdxType="MyLink">
    2.18 Stroke Protocol
  </MyLink>
  and notify Medical Control.
    </Caution>
    <Note id="note-1" alignment="left" mdxType="Note">
  <ul>
    <li>
      <strong>
        Hypoglycemic Emergency:
      </strong>
    </li>
    <li>
      Glucose &lt; 70mg/dL with associated altered mental status.
    </li>
    <li>
      Causes of hypoglycemia include medication misuse or overdose, missed meal,
      fection, cardiovascular insults (e.g., myocardial infarction, arrhythmia), or changes in
      tivity (e.g., exercise).
    </li>
    <li>
      Sulfonylureas (e.g., glyburide, glipizide) have long half-lives ranging from 12-60 hours. Patients
      th corrected hypoglycemia who are taking these agents are at particular risk for recurrent
      mptoms and frequently require hospital admission.
      Hyperglycemic Emergency:
    </li>
    <li>
      Glucose &gt; 300 mg/dL with associated altered mental status
    </li>
  </ul>
    </Note>
    <Note id="note-2" mdxType="Note">
  Dextrose may be administered in any concentration (D10, D25, D50), as long as the correct dose
is given.
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      